import { SET_MYCOURSES } from "./mycourses.types";

export default function mySelectedCourses(state=[], action) {
	switch (action.type) {
		case SET_MYCOURSES:
		  return action.myCourses;
	  
		default:
		  return state;
   }
   
}
